
export class GetUnreadNotificationCountsForDanceManagersResponseDto {
  danceManagerId: string;
  count: number;
}
